import http from "../../../src/util/axios";
import Vue from 'vue';
import config from "../../../config/endpoints";

const PH_URL = config.ph_url;
export default {
  namespaced: true,
  state: {
    indicationList: [],
    medList: [],
    medreqList: []
  },
  mutations: {
   SET_INDICATIONS: function(state,payload){
      state.indicationList = payload
    },
    SET_MEDDETAILS: function(state,payload){
      console.log('set', payload)
      state.medList = payload.display
      state.medreqList = payload.redList
    }
  },
  actions: {
  },
  getters: {
    getIndicationList: state => state.indicationList || [],
    getMedList: state => state.medList || [],
    getMedReqList: state => state.medreqList || []
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/browse.js